import {Box, styled} from '@mui/material';

const SectionBox = styled(Box)(({theme}) => ({
  marginBottom: theme.spacing(4)
}));

export default SectionBox;
